import { DrawerCloseButton, SharedChat } from '@components';
import { useView } from '@hooks';
import { Drawer } from 'antd';
import React from 'react';

interface IProps {
  open: boolean;
  /** Stream channel: the request the job came from, else the job itself. */
  channelId: string;
  /** The customer's app user id - the other member of the channel. */
  customerUserId: number;
  title?: string;
  onClose: () => void;
}

/** The customer conversation for a job, opened from the customer card - was a tab on the order. */
export const ChatDrawer: React.FC<IProps> = ({ open, channelId, customerUserId, title, onClose }) => {
  const { isMobile } = useView();

  return (
    <Drawer
      title={title ?? 'Chat'}
      open={open}
      onClose={onClose}
      styles={{ wrapper: { width: isMobile ? '100%' : 720 }, body: { padding: 0 } }}
      destroyOnHidden
      closable={false}
      extra={<DrawerCloseButton onClick={onClose} />}
    >
      <SharedChat
        chatClassName="chat-drawer-chat"
        hideChannelList
        channelID={channelId}
        filter={customerUserId.toString()}
      />
    </Drawer>
  );
};
